import * as React from 'react';
import * as styles from './styles.css';

export interface IPageProps {
  children: React.ReactChild | React.ReactChild[];
}

export function Page({ children }: IPageProps) {
  return <div className={styles['container']}>{children}</div>;
}
